import React from 'react';

import MobileDevice from '../../Assets/images/Rectangle-160-mobileDevice.png'
import PlayStore from '../../Assets/images/DFplayStore.png'
import AppleStore from '../../Assets/images/DFappleStore.png'

const DownloadmApp = () => {
  return (
    <div className="w-full bg-gray-100">
      <div className="container mx-auto  px-8 md:py-10 py-6 flex flex-col lg:flex-row items-center justify-between">
        {/* Left Section: Text and Button */}
        <div className="text-center lg:text-left lg:w-1/2 mb-4 md:ml-16 lg:mb-0">
          <h1 className="text-xl md:text-4xl font-bold text-gray-800 md:mb-4">
            Download Our Mobile App
          </h1>
          <p className="text-gray-600 md:text-sm text-xs md:mb-6 mb-4">
            Study Abroad Guidance at Your Fingertips
          </p>
          <div className="flex md:pt-32 space-x-3">
            <a href="#">
              <img src={PlayStore} alt="PlayStore" className="w-30 h-auto" />
            </a>
            <a href="#">
              <img src={AppleStore} alt="AppleStore" className="w-30 h-auto" />
            </a>
          </div>
        </div>

        {/* Right Section: Image */}
        <div className="hidden md:block lg:w-1/2 md:pl-48 md:pt-4 pt-0 2xl:ml-[520px] lg:ml-52">
          <img src={MobileDevice} alt="Hero Image" className="w-60 h-auto" />
        </div>
      </div>
    </div>
  );
};

export default DownloadmApp;